import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<path d=\"M3.42871 3.40332L20.9287 20.9033\" stroke=\"#8C8C8C\" stroke-width=\"1.28571\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M3.42871 20.9033L20.9287 3.40332\" stroke=\"#8C8C8C\" stroke-width=\"1.28571\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol